import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./styles/index.scss";

import AppContainerDnD from "../../helpers/contexts/dragDropContext";

class Popup extends Component {
  state = {
    isOpen: false,
  };

  render() {
    return <noscript></noscript>;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.isOpen && prevState.isOpen) {
      return {
        isOpen: false,
      };
    }

    if (nextProps.isOpen && !prevState.isOpen) {
      return {
        isOpen: true,
      };
    }

    return null;
  }

  componentDidMount() {
    this.id = `hidden${Math.random()}`;
    this.renderPopup();
  }

  componentDidUpdate() {
    this.renderPopup();
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.popup);
    document.body.removeChild(this.popup);
  }

  setFocus = (e) => {
    if (
      e &&
      e.target &&
      e.target.nodeName === "DIV" &&
      e.target.className.indexOf("react-selectize") === 0
    ) {
      return true;
    }

    if (
      !(
        e &&
        e.target &&
        ["INPUT", "SELECT", "BUTTON", "TEXTAREA", "path", "svg"].indexOf(
          e.target.nodeName
        ) > -1
      )
    ) {
      this.input.focus();
    }
  };

  closeOnEscape = (event) => {
    if (event.keyCode === 27) {
      this.props.onClosePopup();
    }
  };

  renderPopup() {
    const { children } = this.props;
    const { isOpen } = this.state;

    if (!this.popup) {
      this.popup = document.createElement("div");
      document.body.appendChild(this.popup);
    }

    ReactDOM.render(
      <AppContainerDnD>
        <Provider store={window.store}>
          <div
            className={isOpen ? "popup-overlay open" : "popup-overlay"}
            onKeyUp={this.closeOnEscape}
            onClick={this.setFocus}
          >
            <input
              className="hide"
              id={this.id}
              ref={(node) => {
                this.input = node;
              }}
              type="text"
              autoFocus={true}
            />
            <div className="popup-content">{children}</div>
          </div>
        </Provider>
      </AppContainerDnD>,
      this.popup
    );
  }
}

Popup.propTypes = {
  isOpen: PropTypes.bool,
  onClosePopup: PropTypes.func,
  children: PropTypes.node,
};

export default Popup;
